"use client";

import { useI18n } from "@wojo/localization";
import { Button, ModalBody, ModalFooter, Text } from "@wojo/ui";
import { SuccessIcon } from "../success-icon";
import Link from "next/link";

type SuccessScreenProps = {
    closeModal: () => void;
    redirectLink?: string;
    titleId: string;
};

export const SuccessScreen: React.FC<SuccessScreenProps> = ({
    closeModal,
    redirectLink,
    titleId,
}) => {
    const i18n =
        useI18n("account").account.termsAndConditionsModal.successScreen;

    return (
        <>
            <ModalBody
                style={{
                    textAlign: "center",
                }}
            >
                <SuccessIcon />
                <Text.Heading
                    id={titleId}
                    order="3"
                    tag="h1"
                    style={{
                        color: "var(--s-color-success-standard)",
                        marginBottom: "var(--g-spacing-sm)",
                        marginTop: "var(--g-spacing-lg)",
                    }}
                >
                    {i18n.title.l()}
                </Text.Heading>
                <Text.Body
                    style={{
                        color: "var(--s-color-success-standard)",
                    }}
                >
                    {i18n.description.l()}
                </Text.Body>
            </ModalBody>
            <ModalFooter
                style={{
                    textAlign: "center",
                }}
            >
                {redirectLink ? (
                    <Button
                        palette="success"
                        variant="primary"
                        href={redirectLink}
                        tag={Link}
                    >
                        {i18n.redirectButton.l()}
                    </Button>
                ) : (
                    <Button
                        palette="success"
                        variant="primary"
                        onClick={closeModal}
                        type="button"
                    >
                        {i18n.closeButton.l()}
                    </Button>
                )}
            </ModalFooter>
        </>
    );
};
